import { defineMessages } from '@atlassian/jira-intl'; // TODO - Port i18n string translations to new module ID keys

const messages: {
	tooltipAsc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipDesc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tooltipAsc: {
		id: 'issue-navigator.card-container.sort-button.tooltip-asc',
		defaultMessage: 'Sort ascending',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	tooltipDesc: {
		id: 'issue-navigator.card-container.sort-button.tooltip-desc',
		defaultMessage: 'Sort descending',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});
export default messages;
